module.exports = __webpack_public_path__ + "img/daily-mail.dfedcd1f.png";